<template>
    <button
        type="button"
        class="app-icon-btn"
        :style="{ width: `${size}px`, height: `${size}px` }"
        v-on="$listeners"
    >
        <slot />
    </button>
</template>

<script>
// Round brand-coloured icon button (close, menu, collapse).
//   <app-icon-button :size="34" @click="..."><svg .../></app-icon-button>
// Icons should use stroke/fill="currentColor".
export default {
    name: 'AppIconButton',
    props: {
        size: { type: Number, default: 32 }
    }
};
</script>

<style lang="scss" scoped>
.app-icon-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 0;
    border-radius: 16px;
    border: 1px solid var(--accent);
    background: linear-gradient(180deg, var(--primary) 0%, var(--primary-deep) 100%);
    color: var(--text);
    cursor: pointer;
}
</style>
